import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import PublishIcon from '@material-ui/icons/Publish';

const CustomToolbar = ({ handleUpload }) => (
  <div
    className="ql-toolbar ql-snow"
    id="toolbar"
  >
    <span className="ql-formats">
      <select
        className="ql-font"
        defaultValue="arial"
      >
        <option value="arial">Arial</option>
        <option value="comic-sans">Comic Sans</option>
        <option value="courier-new">Courier New</option>
        <option value="georgia">Georgia</option>
        <option value="helvetica">Helvetica</option>
        <option value="lucida">Lucida</option>
      </select>
      <select
        className="ql-size"
        defaultValue="medium"
      >
        <option value="extra-small">Size 1</option>
        <option value="small">Size 2</option>
        <option value="medium">Size 3</option>
        <option value="large">Size 4</option>
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
      <button className="ql-blockquote" />
    </span>
    <span className="ql-formats">
      <button
        className="ql-list"
        value="ordered"
      />
      <button
        className="ql-list"
        value="bullet"
      />
      <select className="ql-align" />
    </span>
    <span className="ql-formats">
      <select className="ql-color" />
      <select className="ql-background" />
    </span>
    <span className="ql-formats">
      <button className="ql-link" />
      <button className="ql-image" />
    </span>
    <span className="ql-formats">
      <button className="ql-clean" />
    </span>
    {handleUpload && <span className="ql-formats">
      <Tooltip title="Import Document File">
        <button type="button">
          <label style={{ cursor: 'pointer' }}>
            <PublishIcon color="secondary" />
            <input
              accept=".html, .txt"
              onChange={handleUpload}
              style={{ display: 'none' }}
              type="file"
              value=""
            />
          </label>
        </button>
      </Tooltip>
    </span>}
  </div>
);

CustomToolbar.propTypes = {
  handleUpload: PropTypes.func
};

export default CustomToolbar;
